import { apiV2 } from '../api'
import { GetReviewByOrderItemIdResponse } from './dtos/reviews'

export const getProductReviews = async (
  productId: number,
  ratings: number[],
  order = 'latest',
  page = 1
) => {
  const { data } = await apiV2.get(`/canais/avaliacoes/produto/${productId}`, {
    params: {
      order,
      page,
      perPage: 3,
      ratings,
    },
  })

  return data
}

export const getReviewByOrderItemId = async (orderItemId: number) => {
  const { data } = await apiV2.get<GetReviewByOrderItemIdResponse>(
    `/canais/avaliacoes/${orderItemId}`
  )

  return data
}

export const storeReviewProduct = async (
  orderItemId: number,
  rating: number,
  comment?: string
) => {
  await apiV2.post('/canais/avaliacoes', {
    pedido_item_id: orderItemId,
    nota: rating,
    comentario: comment,
  })
}

export const updateReviewProduct = async (
  orderItemId: number,
  rating: number,
  comment?: string
) => {
  await apiV2.put(`/canais/avaliacoes/${orderItemId}`, {
    nota: rating,
    comentario: comment,
  })
}

export const createReviewCommentVote = async (
  commentId: number,
  like: boolean
) => {
  await apiV2.post(`/canais/avaliacoes/${commentId}/curtir`, {
    curtir: like,
  })
}

export const updateReviewCommentVote = async (
  commentId: number,
  like: boolean
) => {
  await apiV2.patch(`/canais/avaliacoes/${commentId}/curtir`, {
    curtir: like,
  })
}

export const deleteReviewCommentVote = async (commentId: number) => {
  await apiV2.delete(`/canais/avaliacoes/${commentId}/curtir`)
}
